import type { IconSvgObject } from './types';

const FlipBottomIcon: IconSvgObject = [
  ["path", { d: "M2.99997 8.99997L2.99997 7.99997M2.99997 4.99997C2.99997 3.34312 4.34312 1.99997 5.99997 1.99997M21 8.99997V7.99997M21 4.99997C21 3.34312 19.6568 1.99997 18 1.99997M9.99997 1.99997L14 1.99997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.99997 13C2.99997 12.4477 3.44768 12 3.99997 12L20 12C20.5523 12 21 12.4477 21 13V19C21 20.6568 19.6568 22 18 22H5.99997C4.34312 22 2.99997 20.6568 2.99997 19L2.99997 13Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FlipBottomIcon;
